export const WITHIN_MAD = {
  name: 'WITHIN_MAD',
  display: 'within_mad_classification'
};

export const BELOW_MAD_OR_QUANTITY_DECREASED = {
  name: 'BELOW_MAD_OR_QUANTITY_DECREASED',
  display: 'below_mad_classification'
};

export const NO_DEVIATION = {
  name: 'NO_DEVIATION',
  display: 'no_deviation_classification'
};